/* 25 oct. 2026 : l'assistant CP interceptait le 1er clic sur « Passer la commande » pour ouvrir le chat
   (proposition du pack confort) au lieu d'aller au paiement. On le marque comme deja vu : le bouton va
   directement au paiement. Le pack reste propose dans le volet panier et sur la fiche produit. */
try{ sessionStorage.setItem('cpasPack','1'); }catch(e){}
/* 25 oct. 2026 : volet « Ajoute au panier », un article sans pointure affichait « Taille Taille unique ». */
(function(){
 function fix(){
  var l=document.querySelectorAll('[data-cpa-s]');
  for(var i=0;i<l.length;i++){
   var t=l[i].textContent, n=t.replace(/^(Taille|Pointure) (Taille|Pointure) /,'Taille ');
   if(n!==t) l[i].textContent=n;
  }
 }
 try{ new MutationObserver(fix).observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
})();
(function(){
 var bar=document.getElementById('brandbar'); if(!bar)return;
 var panes=document.querySelectorAll('.brandpane');
 var vt=function(fn){return document.startViewTransition?document.startViewTransition(fn):fn()};
 bar.addEventListener('click',function(e){
  var b=e.target.closest('.brandchip'); if(!b)return;
  var i=b.dataset.b;
  vt(function(){
   bar.querySelectorAll('.brandchip').forEach(function(x){x.classList.toggle('on',x===b)});
   panes.forEach(function(p){p.classList.toggle('on',p.dataset.pane===i)});
  });
 });
})();
